import * as _ from 'lodash';
import { ApiService } from './api.service';
import { DOC_TEMPLATES } from './constant';
import { TranslateService } from '@ngx-translate/core';
var TemplateService = (function () {
    function TemplateService(apiService, translate) {
        this.apiService = apiService;
        this.translate = translate;
        this.documentTemplates = DOC_TEMPLATES;
        this.getNametitle = '';
    }
    TemplateService.prototype.get = function () {
        return this.documentTemplates;
    };
    TemplateService.prototype.getTemplate = function (type) {
        var template;
        _.forEach(this.documentTemplates, function (obj) {
            if (obj.type === type) {
                template = obj;
            }
        });
        return template;
    };
    TemplateService.prototype.getName = function (type) {
        var template = this.getTemplate(type);
        if (template == null) {
            return null;
        }
        else {
            return template.name;
        }
    };
    TemplateService.prototype.getNameEN = function (type) {
        var template = this.getTemplate(type);
        if (template == null) {
            return null;
        }
        else {
            return template.nameEN;
        }
    };
    TemplateService.prototype.getNameTitle = function (type) {
        if (this.translate.currentLang === 'en') {
            this.getNametitle = this.getNameEN(type);
        }
        if (this.translate.currentLang === 'th') {
            this.getNametitle = this.getName(type);
        }
        return this.getNametitle;
    };
    TemplateService.prototype.getFullName = function (type) {
        var template = this.getTemplate(type);
        if (template == null) {
            return null;
        }
        return template.name + ' (' + template.nameEN + ')';
    };
    TemplateService.prototype.getDropdown = function () {
        var type = [{
                label: this.translate.instant('COMMON.ALL'),
                value: null
            }];
        _.forEach(this.documentTemplates, function (obj) {
            type.push({
                label: obj.name + ' (' + obj.nameEN + ')',
                value: obj.type
            });
        });
        return type;
    };
    return TemplateService;
}());
export { TemplateService };



// WEBPACK FOOTER //
// /opt/app/src/app/services/template.service.ts.pre-build-optimizer.js